<app-header [title]="'all_resources.title' | translate">
  <app-button
    *ngIf="canCreateDevice"
    [black]="true"
    [title]="'Create device'"
    (click)="openCreateDeviceModal()"
    header-button
  ></app-button>
</app-header>

<app-device-table
  [useAllDevices]="true"
  [showDeleteAction]="false"
></app-device-table>
